import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/PublicNav";

export default function Forgot() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await forgotPassword(email);
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-sm space-y-4">
        <Logo />
        {sent ? (
          <div className="dk-card p-8 text-center space-y-3" data-testid="forgot-sent">
            <span className="grid place-items-center w-12 h-12 rounded-full mx-auto" style={{ background: "var(--sage-tint)" }}><Check style={{ color: "var(--sage)" }} /></span>
            <h1 className="font-serif text-[24px] font-semibold">Check your email</h1>
            <p className="text-sm" style={{ color: "var(--text-muted)" }}>If an account exists for that email, we've sent a link to reset your password. It expires in 60 minutes.</p>
            <Link className="link" to="/auth/login">Back to log in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="dk-card p-8 space-y-4" data-testid="forgot-form">
            <h1 className="font-serif text-[24px] font-semibold">Forgot your password?</h1>
            <p className="text-sm" style={{ color: "var(--text-muted)" }}>Enter your email and we'll send a reset link.</p>
            <input className="dk-input" type="email" placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
            <button className="btn btn-primary w-full" disabled={loading} data-testid="forgot-submit">{loading && <Loader2 size={16} className="animate-spin" />} Send reset link</button>
            <p className="text-sm text-center"><Link className="link" to="/auth/login">Back to log in</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
